// Players under this age sign up through a parent; must match copa.age.limit in platform-backend
export const PARENTAL_CONSENT_AGE = 13;
